import React from 'react';
import { Card, Row, Col, Form } from 'react-bootstrap';
const cacheBuster = (url) => `${url}?cb=${Date.now()}`;

const DualCoverageRegistration = (props) => {
  const { values, onChange, hasEditPermission } = props;

  return (
    <Row className="Payment-details member-and-dependent">
      <Col className="pl-0">
        <h3>When Can User Affiliate Dual Coverage?</h3>
        <p className="mb-2">
          Based on your selection, Member will be able to affiliate the other
          Coverage to his account.
        </p>
      </Col>
      <Col className="setup-form">
        <Form.Group className="">
          <Form.Label>
            Allow dual coverage affiliation during Registration
          </Form.Label>
          <Form.Check
            type="checkbox"
            checked={values.whileRegistrationAffiliation}
            id="allowMember"
            onChange={(e) => {
              onChange(e);
            }}
            label="User would be allowed to affiliate the other coverage to his account during Registration"
            name="whileRegistrationAffiliation"
            disabled={!hasEditPermission}
            isDisabled={!hasEditPermission}
            className={!hasEditPermission && 'disabled-checkbox'}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>
            Allow dual coverage affiliation after Registration
          </Form.Label>
          <Form.Check
            type="checkbox"
            checked={values.postRegistrationAffiliation}
            onChange={(e) => {
              onChange(e);
            }}
            id="allowDependent"
            label="User would be allowed to affiliate the other coverage to his account after Registration."
            name="postRegistrationAffiliation"
            disabled={!hasEditPermission}
            isDisabled={!hasEditPermission}
            className={!hasEditPermission && 'disabled-checkbox'}
          />
        </Form.Group>
      </Col>
    </Row>
  );
};

export default DualCoverageRegistration;
